import React from "react"
import { css } from "styled-components"
import {
  ContentfulResponsiveImage as ResponsiveImage,
  IContentfulResponsiveImage,
  RESPONSIVE_IMAGE_TYPENAME,
} from "../../atoms/breakpoint-image"
import VariantContainer from "../../atoms/variant-container"
import Video, { IVideo, VIDEO_TYPENAME } from "../../atoms/video"
import Carousel, {
  CAROUSEL_TYPENAME,
  ICarouselProps,
} from "../../molecules/carousel"
import { ITestimonialCard } from "../../molecules/testimonial-card"

export type TSideBySideMediaComponent =
  | IVideo
  | ICarouselProps
  | IContentfulResponsiveImage
  | ITestimonialCard

const SideBySideMedia = ({
  component,
}: {
  component: TSideBySideMediaComponent
}) => {
  switch (component?.__typename) {
    case CAROUSEL_TYPENAME:
      return (
        <VariantContainer
          variants={{
            md: css`
              margin: 0 48px;
            `,
          }}
        >
          <Carousel {...component} />
        </VariantContainer>
      )
    case RESPONSIVE_IMAGE_TYPENAME:
      return (
        <VariantContainer
          variants={{
            md: css`
              margin: 0 48px;
            `,
          }}
        >
          <ResponsiveImage {...component} />
        </VariantContainer>
      )
    case VIDEO_TYPENAME:
      return (
        <VariantContainer
          variants={[
            css`
              /* push outside bounds of grid on mobile for a full width video */
              margin-left: -20px;
              margin-right: -20px;
              left: 20px;
              right: 20px;
              width: 100vw;
              /* height assuming 16/9 ratio */
              height: calc(100% * 9 / 16);
            `,
            css`
              margin: 0 48px;
              /* unset all others */
              left: unset;
              right: unset;
              width: unset;
              height: unset;
            `,
            css``,
          ]}
        >
          <Video {...component} />
        </VariantContainer>
      )
    default:
      return null
  }
}

export default SideBySideMedia
